import ManufacturersList from '../components/Manufacturers/ManufacturersList';

export default function ManufacturerListPage() {
  return <ManufacturersList />;
}